<div class="d-flex flex-row align-items-center justify-content-start h-100">
  <ng-container *ngIf="value?.length > 0 || value?.length !== null">
    <div
      class="view-details-btn"
      (click)="onViewDetail(value)"
      title="View Details"
    >
      {{ value }}
    </div>
  </ng-container>

  <ng-container *ngIf="p_type === 'lrc'">
    <div class="view-details-btn-2" (click)="onViewDetail(value)">
      View details
    </div>
  </ng-container>
</div>
